import React from 'react';
import './Protfolio.css'
import { VscPreview } from 'react-icons/vsc';

const protfolioData = [
    {
        id: 1,
        img: '',
        title: '',
        discription: '',
        livePreview: ''

    }
]

const Protfolio = () => {
    return (
        <div>
            <div>
                <h2 className="protfolioTitle">Some of My Project</h2>
            </div>
            <section className='protfolio'>
                <div className="card">
                    <div className="box">
                        {/* One */}
                        <div className='content'>
                            <div className="boxImg">
                                <img src="https://i.ibb.co/yV1hBnK/Garden-Go.png" alt="" />
                            </div>
                            <div className="contentCard mt-3">
                                <span className="btn btn-primary btn-sm mr-2">React</span>
                                <span className="btn btn-secondary btn-sm mr-2">Redux</span>
                                <span className="btn btn-danger btn-sm mr-2">Javascript</span>
                            </div>
                            <div className="contentTitle mt-2">
                                <h5>Garden Go</h5>
                            </div>
                            <div className="contentDescription">
                                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate est voluptatum non expedita necessitatibus</p>
                            </div>
                            <div className="contentDetails d-flex justify-content-center mb-5">
                                <button className='btn btn-outline-danger '>Details</button>
                                <a href="https://garden-go.web.app/" target="_blank" ><button className='btn btn-danger ml-3 '><VscPreview className='ProtfolioLivePreview' /> Live Preview</button></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="box">
                        {/* Two */}
                        <div className='content'>
                            <div className="boxImg">
                                <img src="https://i.ibb.co/hxGQ20z/photography.png" alt="" />
                            </div>
                            <div className="contentCard mt-3">
                                <span className="btn btn-danger btn-sm mr-2">React</span>
                                <span className="btn btn-secondary btn-sm mr-2">React Router</span>
                                <span className="btn btn-primary btn-sm mr-2">Node</span>


                            </div>
                            <div className="contentTitle mt-2">
                                <h5>Dhoku Photography</h5>
                            </div>
                            <div className="contentDescription">
                                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate est voluptatum non expedita necessitatibus</p>
                            </div>
                            <div className="contentDetails d-flex justify-content-center mb-5">
                                <button className='btn btn-outline-danger '>Details</button>
                                <a href="https://dhoku-photography.web.app/" target="_blank"> <button className='btn btn-danger ml-3 '><VscPreview className='ProtfolioLivePreview' /> Live Preview</button></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="box">
                        {/* Three */}
                        <div className='content'>
                            <div className="boxImg">
                                <img src="https://i.ibb.co/cxFW8BL/Protfolio-Desing-Card.png" alt="" />
                            </div>
                            <div className="contentCard mt-3">
                                <span className="btn btn-warning btn-sm mr-2">React</span>
                                <span className="btn btn-secondary btn-sm mr-2">Node</span>
                                <span className="btn btn-danger btn-sm mr-2">MongoDB</span>

                            </div>
                            <div className="contentTitle mt-2">
                                <h5>Education Learner</h5>
                            </div>
                            <div className="contentDescription">
                                <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate est voluptatum non expedita necessitatibus</p>
                            </div>
                            <div className="contentDetails d-flex justify-content-center mb-5">
                                <button className='btn btn-outline-danger '>Details</button>

                                <a target="_blank" href="https://dhok-boi-bazar.web.app/"><button className='btn btn-danger ml-3 '><VscPreview className='ProtfolioLivePreview' /> Live Preview</button></a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="moreBtn d-flex justify-content-center">
                <a href="/protfolio" class="d-flex justify-content-center">
                    <button className="d-flex justify-content-center btn btn-outline-danger ">See More</button>
                </a>
            </div>
        </div>

    );
};

export default Protfolio;